import { render, staticRenderFns } from "./ButtonWithOptions.vue?vue&type=template&id=04a7f1ba&scoped=true&"
import script from "./ButtonWithOptions.vue?vue&type=script&lang=js&"
export * from "./ButtonWithOptions.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithOptions.vue?vue&type=style&index=0&id=04a7f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a7f1ba",
  null
  
)

export default component.exports